export const isChatRestriction = (detail) => ['chat_timeout', 'chat_ban'].includes(detail?.code);

export const currentChatRestriction = (state, now) => {
  for (const code of ['chat_ban', 'chat_timeout']) {
    const value = state?.[code];
    if (!value?.active) continue;
    const until = value.until ? Date.parse(value.until) : null;
    if (until !== null && Number.isFinite(until) && until <= now) continue;
    return { ...value, code, remaining: until !== null && Number.isFinite(until) ? Math.max(0, Math.ceil((until - now) / 1000)) : null };
  }
  return null;
};

export const restrictionCountdown = (seconds) => {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const pad = (value) => String(value).padStart(2, '0');
  return `${days ? `${days}d ` : ''}${days || hours ? `${pad(hours)}:` : ''}${pad(minutes)}:${pad(seconds % 60)}`;
};

export const chatRestrictionMessage = (restriction) => {
  const timeout = restriction.code === 'chat_timeout';
  if (!restriction.until && !timeout) return 'You have been permanently banned from chat.';
  const seconds = restriction.duration_seconds || Math.round((Date.parse(restriction.until) - Date.parse(restriction.created_at)) / 1000);
  let duration = '';
  if (Number.isFinite(seconds) && seconds > 0) {
    const unit = !timeout && seconds % 86400 === 0 ? ['day', 86400] : seconds % 3600 === 0 ? ['hour', 3600] : seconds % 60 === 0 ? ['minute', 60] : ['second', 1];
    const value = seconds / unit[1];
    duration = ` for ${value} ${unit[0]}${value === 1 ? '' : 's'}`;
  }
  return `You have been ${timeout ? 'timed out' : 'banned from chat'}${duration}.`;
};